// change to json file

export const productList = [
  // WOMEN COATS
  {
    id: 101,
    img: '../img/coat-female.png',
    title: 'Womans coat one',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 240,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'women-coats',
    gender: 'female'
  },
  {
    id: 102,
    img: '../img/coat-female.png',
    title: 'Womans coat two',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 260,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'women-coats',
    gender: 'female'
  },
  {
    id: 103,
    img: '../img/coat-female.png',
    title: 'Womans coat three',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 280,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'women-coats',
    gender: 'female'
  },
  {
    id: 104,
    img: '../img/coat-female.png',
    title: 'Womans coat four',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 210,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'women-coats',
    gender: 'female'
  },
  {
    id: 105,
    img: '../img/coat-female.png',
    title: 'Womans coat five',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 330,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'women-coats',
    gender: 'female'
  },
  {
    id: 106,
    img: '../img/coat-female.png',
    title: 'Womans coat six',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 440,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'women-coats',
    gender: 'female'
  },

  // WOMEN JACKETS
  {
    id: 111,
    img: '../img/jacket-female.png',
    title: 'Womans jacket one',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 300,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'women-jackets',
    gender: 'female'
  },
  {
    id: 112,
    img: '../img/jacket-female.png',
    title: 'Womans jacket two',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 290,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'women-jackets',
    gender: 'female'
  },
  {
    id: 113,
    img: '../img/jacket-female.png',
    title: 'Womans jacket three',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 280,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'women-jackets',
    gender: 'female'
  },
  {
    id: 114,
    img: '../img/jacket-female.png',
    title: 'Womans jacket four',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 260,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'women-jackets',
    gender: 'female'
  },
  {
    id: 115,
    img: '../img/jacket-female.png',
    title: 'Womans jacket five',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 230,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'women-jackets',
    gender: 'female'
  },
  {
    id: 116,
    img: '../img/jacket-female.png',
    title: 'Womans jacket six',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 400,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'women-jackets',
    gender: 'female'
  },

  // WOMEN HATS
  {
    id: 121,
    img: '../img/hat-female.png',
    title: 'Womans hat one',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 120,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'women-hats',
    gender: 'female'
  },
  {
    id: 122,
    img: '../img/hat-female.png',
    title: 'Womans hat two',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 50,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'women-hats',
    gender: 'female'
  },
  {
    id: 123,
    img: '../img/hat-female.png',
    title: 'Womans hat three',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 120,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'women-hats',
    gender: 'female'
  },
  {
    id: 124,
    img: '../img/hat-female.png',
    title: 'Womans hat four',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 100,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'women-hats',
    gender: 'female'
  },
  {
    id: 125,
    img: '../img/hat-female.png',
    title: 'Womans hat five',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 80,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'women-hats',
    gender: 'female'
  },
  {
    id: 126,
    img: '../img/hat-female.png',
    title: 'Womans hat six',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 90,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'women-hats',
    gender: 'female'
  },

  // WOMEN SHIRTS
  {
    id: 131,
    img: '../img/shirt-female.png',
    title: 'Womans shirt one',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 200,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'women-shirts',
    gender: 'female'
  },
  {
    id: 132,
    img: '../img/shirt-female.png',
    title: 'Womans shirt two',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 120,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'women-shirts',
    gender: 'female'
  },
  {
    id: 133,
    img: '../img/shirt-female.png',
    title: 'Womans shirt three',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 160,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'women-shirts',
    gender: 'female'
  },
  {
    id: 134,
    img: '../img/shirt-female.png',
    title: 'Womans shirt four',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 190,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'women-shirts',
    gender: 'female'
  },
  {
    id: 135,
    img: '../img/shirt-female.png',
    title: 'Womans shirt five',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 100,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'women-shirts',
    gender: 'female'
  },
  {
    id: 136,
    img: '../img/shirt-female.png',
    title: 'Womans shirt six',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 110,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'women-shirts',
    gender: 'female'
  },

  // WOMEN SHOES
  {
    id: 141,
    img: '../img/shoes-female.png',
    title: 'Womans shoes one',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 290,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'women-shoes',
    gender: 'female'
  },
  {
    id: 142,
    img: '../img/shoes-female.png',
    title: 'Womans shoes two',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 280,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'women-shoes',
    gender: 'female'
  },
  {
    id: 143,
    img: '../img/shoes-female.png',
    title: 'Womans shoes three',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 300,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'women-shoes',
    gender: 'female'
  },
  {
    id: 144,
    img: '../img/shoes-female.png',
    title: 'Womans shoes four',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 500,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'women-shoes',
    gender: 'female'
  },
  {
    id: 145,
    img: '../img/shoes-female.png',
    title: 'Womans shoes five',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 180,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'women-shoes',
    gender: 'female'
  },
  {
    id: 146,
    img: '../img/shoes-female.png',
    title: 'Womans shoes six',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 220,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'women-shoes',
    gender: 'female'
  },

  // WOMEN SUITS
  {
    id: 151,
    img: '../img/suit-female.png',
    title: 'Womans suit one',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 500,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'women-suits',
    gender: 'female'
  },
  {
    id: 152,
    img: '../img/suit-female.png',
    title: 'Womans suit two',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 590,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'women-suits',
    gender: 'female'
  },
  {
    id: 153,
    img: '../img/suit-female.png',
    title: 'Womans suit three',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 580,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'women-suits',
    gender: 'female'
  },
  {
    id: 154,
    img: '../img/suit-female.png',
    title: 'Womans suit four',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 560,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'women-suits',
    gender: 'female'
  },
  {
    id: 155,
    img: '../img/suit-female.png',
    title: 'Womans suit five',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 530,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'women-suits',
    gender: 'female'
  },
  {
    id: 156,
    img: '../img/suit-female.png',
    title: 'Womans suit six',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 500,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'women-suits',
    gender: 'female'
  },

  // WOMEN T-SHIRTS
  {
    id: 161,
    img: '../img/t-shirt-female.png',
    title: 'Womans t-shirt one',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 120,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'women-t-shirts',
    gender: 'female'
  },
  {
    id: 162,
    img: '../img/t-shirt-female.png',
    title: 'Womans t-shirt two',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 80,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'women-t-shirts',
    gender: 'female'
  },
  {
    id: 163,
    img: '../img/t-shirt-female.png',
    title: 'Womans t-shirt three',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 110,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'women-t-shirts',
    gender: 'female'
  },
  {
    id: 164,
    img: '../img/t-shirt-female.png',
    title: 'Womans t-shirt four',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 200,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'women-t-shirts',
    gender: 'female'
  },
  {
    id: 165,
    img: '../img/t-shirt-female.png',
    title: 'Womans t-shirt five',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 180,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'women-t-shirts',
    gender: 'female'
  },
  {
    id: 166,
    img: '../img/t-shirt-female.png',
    title: 'Womans t-shirt six',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 150,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'women-t-shirts',
    gender: 'female'
  },

  // MEN COATS
  {
    id: 201,
    img: '../img/coat-male.png',
    title: 'Mens coat one',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 400,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'men-coats',
    gender: 'male'
  },
  {
    id: 202,
    img: '../img/coat-male.png',
    title: 'Mens coat two',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 440,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'men-coats',
    gender: 'male'
  },
  {
    id: 203,
    img: '../img/coat-male.png',
    title: 'Mens coat three',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 290,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'men-coats',
    gender: 'male'
  },
  {
    id: 204,
    img: '../img/coat-male.png',
    title: 'Mens coat four',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 220,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'men-coats',
    gender: 'male'
  },
  {
    id: 205,
    img: '../img/coat-male.png',
    title: 'Mens coat five',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 230,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'men-coats',
    gender: 'male'
  },
  {
    id: 206,
    img: '../img/coat-male.png',
    title: 'Mens coat six',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 350,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'men-coats',
    gender: 'male'
  },

  // MEN HATS
  {
    id: 211,
    img: '../img/hat-male.png',
    title: 'Mens hat one',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 90,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'men-hats',
    gender: 'male'
  },
  {
    id: 212,
    img: '../img/hat-male.png',
    title: 'Mens hat two',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 80,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'men-hats',
    gender: 'male'
  },
  {
    id: 213,
    img: '../img/hat-male.png',
    title: 'Mens hat three',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 120,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'men-hats',
    gender: 'male'
  },
  {
    id: 214,
    img: '../img/hat-male.png',
    title: 'Mens hat four',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 200,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'men-hats',
    gender: 'male'
  },
  {
    id: 215,
    img: '../img/hat-male.png',
    title: 'Mens hat five',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 110,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'men-hats',
    gender: 'male'
  },
  {
    id: 216,
    img: '../img/hat-male.png',
    title: 'Mens hat six',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 180,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'men-hats',
    gender: 'male'
  },

  // MEN JACKETS
  {
    id: 221,
    img: '../img/jacket-male.png',
    title: 'Mens jacket one',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 200,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'men-jackets',
    gender: 'male'
  },
  {
    id: 222,
    img: '../img/jacket-male.png',
    title: 'Mens jacket two',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 220,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'men-jackets',
    gender: 'male'
  },
  {
    id: 223,
    img: '../img/jacket-male.png',
    title: 'Mens jacket three',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 290,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'men-jackets',
    gender: 'male'
  },
  {
    id: 224,
    img: '../img/jacket-male.png',
    title: 'Mens jacket four',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 180,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'men-jackets',
    gender: 'male'
  },
  {
    id: 225,
    img: '../img/jacket-male.png',
    title: 'Mens jacket five',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 320,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'men-jackets',
    gender: 'male'
  },
  {
    id: 226,
    img: '../img/jacket-male.png',
    title: 'Mens jacket six',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 330,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'men-jackets',
    gender: 'male'
  },

  // MEN SHIRTS
  {
    id: 231,
    img: '../img/shirt-male.png',
    title: 'Mens shirt one',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 200,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'men-shirts',
    gender: 'male'
  },
  {
    id: 232,
    img: '../img/shirt-male.png',
    title: 'Mens shirt two',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 220,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'men-shirts',
    gender: 'male'
  },
  {
    id: 233,
    img: '../img/shirt-male.png',
    title: 'Mens shirt three',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 290,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'men-shirts',
    gender: 'male'
  },
  {
    id: 234,
    img: '../img/shirt-male.png',
    title: 'Mens shirt four',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 180,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'men-shirts',
    gender: 'male'
  },
  {
    id: 235,
    img: '../img/shirt-male.png',
    title: 'Mens shirt five',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 300,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'men-shirts',
    gender: 'male'
  },
  {
    id: 236,
    img: '../img/shirt-male.png',
    title: 'Mens shirt six',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 400,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'men-shirts',
    gender: 'male'
  },

  // MEN SHOES
  {
    id: 241,
    img: '../img/shoes-male.png',
    title: 'Mens shoes one',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 250,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'men-shoes',
    gender: 'male'
  },
  {
    id: 242,
    img: '../img/shoes-male.png',
    title: 'Mens shoes two',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 850,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'men-shoes',
    gender: 'male'
  },
  {
    id: 243,
    img: '../img/shoes-male.png',
    title: 'Mens shoes three',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 340,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'men-shoes',
    gender: 'male'
  },
  {
    id: 244,
    img: '../img/shoes-male.png',
    title: 'Mens shoes four',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 270,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'men-shoes',
    gender: 'male'
  },
  {
    id: 245,
    img: '../img/shoes-male.png',
    title: 'Mens shoes five',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 280,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'men-shoes',
    gender: 'male'
  },
  {
    id: 246,
    img: '../img/shoes-male.png',
    title: 'Mens shoes six',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 290,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'men-shoes',
    gender: 'male'
  },

  // MEN SUITS
  {
    id: 251,
    img: '../img/suit-male.png',
    title: 'Mens suit one',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 400,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'men-suits',
    gender: 'male'
  },
  {
    id: 252,
    img: '../img/suit-male.png',
    title: 'Mens suit two',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 500,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'men-suits',
    gender: 'male'
  },
  {
    id: 253,
    img: '../img/suit-male.png',
    title: 'Mens suit three',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 550,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'men-suits',
    gender: 'male'
  },
  {
    id: 254,
    img: '../img/suit-male.png',
    title: 'Mens suit four',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 600,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'men-suits',
    gender: 'male'
  },
  {
    id: 255,
    img: '../img/suit-male.png',
    title: 'Mens suit five',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 380,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'men-suits',
    gender: 'male'
  },
  {
    id: 256,
    img: '../img/suit-male.png',
    title: 'Mens suit six',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 420,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'men-suits',
    gender: 'male'
  },

  // MEN T-SHIRTS
  {
    id: 261,
    img: '../img/t-shirt-male.png',
    title: 'Mens t-shirt one',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 120,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'men-t-shirts',
    gender: 'male'
  },
  {
    id: 262,
    img: '../img/t-shirt-male.png',
    title: 'Mens t-shirt two',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 100,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'men-t-shirts',
    gender: 'male'
  },
  {
    id: 263,
    img: '../img/t-shirt-male.png',
    title: 'Mens t-shirt three',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 180,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'men-t-shirts',
    gender: 'male'
  },
  {
    id: 264,
    img: '../img/t-shirt-male.png',
    title: 'Mens t-shirt four',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 200,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'men-t-shirts',
    gender: 'male'
  },
  {
    id: 265,
    img: '../img/t-shirt-male.png',
    title: 'Mens t-shirt five',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 70,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'men-t-shirts',
    gender: 'male'
  },
  {
    id: 266,
    img: '../img/t-shirt-male.png',
    title: 'Mens t-shirt six',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
    price: 160,
    inCart: false,
    inWishlist: false,
    amount: 0,
    total: 0,
    size: null,
    category: 'men-t-shirts',
    gender: 'male'
  },
]

export const initProduct = {
  id: 101,
  img: '../img/coat-female.png',
  title: 'Womans coat one',
  subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
  description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, quis deserunt. Aperiam minima facere dolorem saepe deleniti aspernatur amet molestiae doloremque, sed quam ullam cum veritatis corporis eius sequi magnam ipsum aliquid eum! Saepe dolorum debitis voluptate culpa veniam molestiae mollitia dignissimos velit reprehenderit voluptatibus numquam omnis aperiam, cum facere.',
  price: 240,
  inCart: false,
  inWishlist: false,
  amount: 0,
  total: 0,
  size: null,
  category: 'women-coats',
  gender: 'female'
};